export default __webpack_public_path__ + "static/custom-c1d5f1ee79948c7d9e06262786af2516.png";